import { trimStart } from 'lodash'
import { GrRegex } from './helpers'

interface IPostalCodeSeparatorValidParams {
  postalCode: string
  separators: string[]
  position: number
}

export const isSeparatorUniqueAndPositionValid = ({
  postalCode,
  separators,
  position,
}: IPostalCodeSeparatorValidParams) => {
  for (const separator of separators) {
    if (
      postalCode.includes(separator) &&
      !(postalCode.split(separator).length - 1 === 1 && postalCode.charAt(position) === separator)
    ) {
      return false
    }
  }
  return true
}

export const isValidPostalCodeCA = (postalCode: string) => {
  if (postalCode === '*') return true

  const isSeparatorValid = isSeparatorUniqueAndPositionValid({
    postalCode,
    separators: [' '],
    position: 3,
  })
  const alphanumericPostalCode = postalCode.replace(/[\s\-*]/g, '')
  const isAlphanumericValid = GrRegex.postalCodeCA.test(alphanumericPostalCode)

  const isAsteriskValid =
    (alphanumericPostalCode.length === 6 && !postalCode.includes('*')) ||
    (alphanumericPostalCode.length < 6 &&
      postalCode.split('*').length - 1 === 1 &&
      postalCode.charAt(postalCode.length - 1) === '*')

  return isSeparatorValid && isAsteriskValid && isAlphanumericValid
}

export const removeNonAlphaNumericPostalCode = (str: string) => str.replace(/[^*,a-zA-Z0-9\s]/g, '')

export const replaceConsecutiveAsterisks = (str: string) => str.replace(/\*+/g, '*')

export const replaceConsecutiveCommas = (str: string) => str.replace(/,+/g, ',')

export const normalizeWhitespace = (str: string) => str.replace(/\s+/g, ' ')

export const sanitizePostalCodesInput = (value: string) => {
  const noLeadingSpaceValue = trimStart(value)
  const alphanumericValue = removeNonAlphaNumericPostalCode(noLeadingSpaceValue)
  const valueWithSingleAsterisks = replaceConsecutiveAsterisks(alphanumericValue)
  const valueWithSingleCommas = replaceConsecutiveCommas(valueWithSingleAsterisks)
  const valueWithSingleWhitespace = normalizeWhitespace(valueWithSingleCommas)
  return valueWithSingleWhitespace.toUpperCase()
}

export const sanitizeLocationNameInput = (value: string) => {
  const valueWithoutleadingSpace = trimStart(value)
  const valueWithSingleWhitespace = normalizeWhitespace(valueWithoutleadingSpace)
  return valueWithSingleWhitespace.replace(GrRegex.specialCharacters, '')
}
